import { api } from "../../../api/api.js";
import "../../../model/middleware/index.js";
import { selectAllFilterValues } from "../../../model/selectors/selectAllFilterValues.js";
import { selectAllFilterValuesParameters } from "../../../model/selectors/selectAllFilterValuesParameters.js";
import { selectAvailableFilterValues } from "../../../model/selectors/selectAvailableFilterValues.js";
import { selectAvailableFilterValuesParameters } from "../../../model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../model/selectors/selectDependentFilterKeysByKey.js";
import "../../../model/selectors/selectFilterImmutableQueries.js";
import "../../../model/selectors/selectFilterImmutableValues.js";
import "../../../model/selectors/selectFilterItemByKey.js";
import "../../../model/selectors/selectFilterItems.js";
import "../../../model/selectors/selectFilterValuesFields.js";
import "../../../model/selectors/selectGroupedFilterItemByKey.js";
import "../../../model/selectors/selectIsFilterValuesMissing.js";
import "../../../../../shared/lib/store/createAppApi.js";
import "../../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../../shared/lib/store/createAppSelector.js";
import "../../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../../shared/lib/store/hooks/useAppStore.js";
const useFilterValues = () => {
  const allFilterValuesParameters = useAppSelector(selectAllFilterValuesParameters);
  const availableFilterValuesParameters = useAppSelector(selectAvailableFilterValuesParameters);
  const allFilterValuesQueryResultFromStore = useAppSelector(selectAllFilterValues);
  const filterValuesQueryResult = api.useGetAllFilterValuesQuery(allFilterValuesParameters);
  const availableFilterValuesQueryResultFromStore = useAppSelector(selectAvailableFilterValues);
  const availableFilterValuesQueryResult = api.useGetAvailableFilterValuesQuery(
    availableFilterValuesParameters,
    {
      skip: !allFilterValuesQueryResultFromStore.data
    }
  );
  return {
    ...availableFilterValuesQueryResult,
    currentData: availableFilterValuesQueryResult.currentData,
    data: availableFilterValuesQueryResult.data ?? availableFilterValuesQueryResultFromStore.data,
    isUninitialized: availableFilterValuesQueryResultFromStore.isUninitialized ? filterValuesQueryResult.isUninitialized : false,
    isLoading: filterValuesQueryResult.isLoading || availableFilterValuesQueryResult.isLoading,
    isFetching: availableFilterValuesQueryResult.isFetching,
    isSuccess: filterValuesQueryResult.isSuccess && availableFilterValuesQueryResult.isSuccess,
    error: filterValuesQueryResult.error || availableFilterValuesQueryResult.error,
    isError: filterValuesQueryResult.isError || availableFilterValuesQueryResult.isError,
    status: availableFilterValuesQueryResultFromStore.isUninitialized ? availableFilterValuesQueryResult.status : availableFilterValuesQueryResultFromStore.status
  };
};
export {
  useFilterValues
};
